export const copy = {
  'en': {
    'key1': 'Page Not Found',
  },
  'de': {
    'key1': 'Zeite nicht gefunden',
  }
};